import { AxiosError } from 'axios'
import { persist } from 'zustand/middleware'
import create from 'zustand'
import { Applicant } from '../requestModels'

// Base state interface
interface InfluencerState {
  influencer: Applicant | null
  content: string[]
  isLoading: boolean
  error: AxiosError<unknown, any> | null
}

// Store interface: includes state + actions
interface IInfluencerState extends InfluencerState {
  setInfluencer: (influencer: Applicant) => void
  setContent: (content: string[]) => void
  clearInfluencer: () => void
  setLoading: (isLoading: boolean) => void
  setError: (error: AxiosError<unknown, any> | null) => void
  reset: () => void
}

const influencerInitialState: InfluencerState = {
  influencer: null,
  content: [],
  isLoading: false,
  error: null
}

export const useInfluencerStore = create<IInfluencerState>(
  persist(
    set => ({
      ...influencerInitialState,

      setInfluencer: (influencer: Applicant) => set({ influencer, isLoading: false, error: null }),

      setContent: (content: string[]) => set({ content, isLoading: false, error: null }),

      clearInfluencer: () => set({ influencer: null }),

      setLoading: (isLoading: boolean) => set({ isLoading }),

      setError: (error: AxiosError<unknown, any> | null) => set({ error, isLoading: false }),

      reset: () => set(influencerInitialState)
    }),
    {
      name: 'influencer-storage',
      partialize: state => ({ influencer: state.influencer, content: state.content })
    }
  )
)
